import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/object-fit/ls.object-fit';

import sal from 'sal.js'

import Featherlight from 'featherlight';

// import { collapsibleSections } from './components/collapsible-sections';
import { nav } from './components/nav';
import { collapsibleText } from './components/collapsible-text';
import { windowWatcher } from './components/window-watcher';

window.main = window.main || {};

const $body = $('body');

let isHomepage = false;
let isTouchDevice = false;

main.init = () => {

  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }

  sal({
    threshold: 0.01
  });

  function checkIfTouchDevice(){
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
  }

  if(checkIfTouchDevice() === true) {
    $body.addClass('is-touch');
    $body.addClass('is-mobile-device');
    isTouchDevice = true;
  }
  else {
    isTouchDevice = false;
  }

  if($body.hasClass('page--is-homepage')) {
    isHomepage = true;
  }

  windowWatcher();
  nav(isHomepage,isTouchDevice);
  collapsibleText();

};

$(main.init);
